import styles from './SignedInDashboard.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import SavedSearchesDashboard from 'SavedSearchesDashboard/SavedSearchesDashboard';
import SavedJobsDashboard from 'SavedJobsDashboard/SavedJobsDashboard';
import RecommendedJobsDashboard from 'RecommendedJobsDashboard/RecommendedJobsDashboard';
import DashboardError from 'DashboardError/DashboardError';

const mapStateToProps = ({ dashboard }) => ({
  ready: dashboard.ready,
  error: dashboard.error,
  expand: dashboard.expand
});

@connect(mapStateToProps)
class SignedInDashboard extends Component {

  static propTypes = {
    ready: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
    expand: PropTypes.bool.isRequired
  };

  render() {
    const { ready, error, expand } = this.props;

    return (
      <div
        data-automation="signedInDashboard"
        className={classnames({
          [styles.root]: true,
          [styles.root_isReady]: ready,
          [styles.root_isExpanded]: expand
        })}>

        {
          error ?
            <DashboardError message={error} /> :
            <div className={styles.content} data-automation="signedInDashboardContent">

              <div className={styles.contentInner}>
                <SavedSearchesDashboard />
              </div>

              <div className={styles.divider} />

              <div className={styles.contentInner}>
                <SavedJobsDashboard />
              </div>

              <div className={styles.divider} />

              <div className={styles.contentInner}>
                <RecommendedJobsDashboard />
              </div>

            </div>
        }

        <div className={styles.backdrop} />
      </div>
    );
  }
}
export default SignedInDashboard;



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/SignedInDashboard.js
 **/